import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as TrashIcon } from '../../../../assets/images/trashcanIcon.svg';
import Button from '../../../../components/shared/Button/Button';
import Modal from '../../../../components/shared/Modal/Modal.jsx';
import { IsMobile } from '../../../../helpers/IsMobile';

import styles from './MergeModal.module.scss';

const MergeModal = ({ showModal, handleToggleMergeModal, handleMergeYes, contactsToMerge }) => {
  const { t } = useTranslation('common');
  const isMobile = IsMobile();

  return (
    <Modal
      show={showModal}
      onHide={handleToggleMergeModal}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      fullscreen={isMobile}
    >
      <Modal.CustomHeader closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{t('modals.areYouSure')}</Modal.Title>
      </Modal.CustomHeader>
      <Modal.Body>
        <div className={styles.editorCont}>
          <span className={styles.trashIcon}>
            <TrashIcon />
          </span>
          <p className={styles.confirmationText}>
            {contactsToMerge.length > 2
              ? t('modals.confirmMergeMultiple', { count: contactsToMerge.length })
              : t('modals.confirmMergeBoth')}
          </p>
        </div>
      </Modal.Body>
      <Modal.CustomFooter>
        <Button variant="outline-primary" onClick={handleMergeYes} className={styles.yesNoBtn}>
          {t('yes')}
        </Button>
        <Button variant="primary" onClick={handleToggleMergeModal} className={styles.yesNoBtn}>
          {t('no')}
        </Button>
      </Modal.CustomFooter>
    </Modal>
  );
};

export default MergeModal;
